import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';


/**
 * Get gazetters by text
 * */
export function* getListGazetters() {
    const response = yield call(api.loadGazetteerIndex);

    if (response.status === 200) {
        yield put({
            type: actionTypes.LIST_GAZETTERS.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Success get list gazetters',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: 'Error',
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });

    yield put({
        type: actionTypes.LIST_GAZETTERS.FAILURE,
        errors,
    });

    return response;
}


/**
 * Get gazetters by text
 * */
export function* postGazetters(text, options = {}) {
    try {
        const response = yield call(api.postGazetters, text, options);
        console.log('response', response);
        if (response.status === 200) {
            yield put({
                type: actionTypes.POST_GAZETTERS.SUCCESS,
                data: response.data.gazetteers,
            });

            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Success',
                    message: 'Success post and get gazzeters',
                    level: 'success',
                    _id: Math.random(),
                    autoDismiss: 2,
                },
            });

            return response;
        }
    } catch (errors) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Error',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        yield put({
            type: actionTypes.POST_GAZETTERS.FAILURE,
            errors,
        });
    }
}

export function* watchPostGazetters() {
    while (true) {
        const { text, options } = yield take(actionTypes.POST_GAZETTERS.REQUEST);
        yield call(postGazetters, text, options);
    }
}

/**
 * Get gazetters by text
 * 
 * @param {*} gazetters
 * @returns {Object} response
 * */
export function* saveGazetters(gazetters) {
    const response = yield call(api.saveGazetters, gazetters);
    if (response.status === 200) {
        yield put({
            type: actionTypes.SAVE_GAZETTERS.SUCCESS,
            data: gazetters,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Success save gazetters',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    throw response;
}

export function* watchSaveGazetters() {
    while (true) {
        const { gazetters } = yield take(actionTypes.SAVE_GAZETTERS.REQUEST);

        try {
            yield call(saveGazetters, gazetters);
        } catch (error) {
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: error.message,
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2,
                },
            });

            yield put({
                type: actionTypes.SAVE_GAZETTERS.FAILURE,
                errors: error.message,
            });

            return error;
        }
    }
}

/**
 * Get gazetters by text
 * 
 * @param {*} gazetters
 * @returns {Object} response
 * */
export function* saveGazettersNew(gazetters) {
    const response = yield call(api.saveGazettersNew, gazetters);

    if (!response) {
        yield put({
            type: actionTypes.SAVE_GAZETTERS_NEW.SUCCESS,
            data: gazetters,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Success save new gazetters',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return { status: 204 };
    } 
}

export function* watchSaveGazettersNew() {
    while (true) {
        const { gazetters } = yield take(actionTypes.SAVE_GAZETTERS_NEW.REQUEST);

        try {
            yield call(saveGazetters, gazetters);
        } catch (error) {
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: error.message,
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2,
                },
            });

            yield put({
                type: actionTypes.SAVE_GAZETTERS_NEW.FAILURE,
                errors: error.message,
            });

            return error;
        }
    }
}

export default [watchPostGazetters, watchSaveGazetters, watchSaveGazettersNew];



// WEBPACK FOOTER //
// ./app/sagas/gazetters.js